import Vue from 'vue'
// import * as Cookie from '@/utils/cookie'
import { Toast } from 'vant'
import * as Cookie from './cookie'

const initialOptions = {
    method: 'get'
}

const request = (options = initialOptions) => {
    return new Promise((resolve, reject) => {
        Vue.http({
            ...options,
            headers: {
                Authorization: Cookie.get('access_token')
            }
        }).then((res) => {
            resolve(res)
        }, (err) => {
            // errorFormate(err)
            if (err.status !== 0) {
                console.log(err)
                Toast(err?.body?.message || '请求出错，请重试')

                if (err.status == 403) {
                    Cookie.remove('uid')
                    Cookie.remove('access_token')
                    switch (Vue.prototype.GLOBAL.source) {
                        case 'sun':
                            window.location.replace('/quiz')
                            break;
                        case 'agriculture':
                            window.location.replace('/quiz/agriculture')
                            break;
                        case 'cac':
                            window.location.replace('/cac')
                            break;
                        case 'icif':
                            window.location.replace('/icif')
                            break;
                        default:
                            window.location.replace('/quiz')
                            break;
                    }
                }
                reject(err)
            }
        })
    })
}

export default request
